import ApiService from "@/services/api.service";

// ACTIONS
export const LIST_PERMISSIONS = "listPermissions";
export const CREATE_PERMISSION = "createPermisssion";
export const UPDATE_PERMISSION = "updatePermission";
export const DELETE_PERMISSION = "deletePermission";

// MUTATIONS
export const SET_LIST_PERMISSIONS = "setListpermissions";
export const SET_ERROR = "setError";

const state = {
    error: {},
    listPermissions: {},
};

const getters = {};

const actions = {
    [LIST_PERMISSIONS](context, query) {
        return new Promise((resolve) => {
            ApiService.get(`Permissions?${query}`)
                .then((res) => {
                    this.state.permissions.listPermissions.length = 0;
                    context.commit(SET_LIST_PERMISSIONS, res.data);
                    resolve(res);
                })
                .catch(({ response }) => {
                    context.commit(SET_ERROR, response?.data?.message);
                    setTimeout(() => context.commit(SET_ERROR, ""), 5000);
                });
        });
    },

    [CREATE_PERMISSION](context, params) {
        return new Promise((resolve) => {
            ApiService.post(`Permissions`, params)
                .then((res) => {
                    resolve(res);
                })
                .catch(({ response }) => {
                    context.commit(SET_ERROR, response?.data?.message);
                    setTimeout(() => context.commit(SET_ERROR, ""), 5000);
                });
        });
    },

    [UPDATE_PERMISSION](context, params) {
        return new Promise((resolve) => {
            ApiService.update(`Permissions`, params.id, params)
                .then((res) => {
                    resolve(res);
                })
                .catch(({ response }) => {
                    context.commit(SET_ERROR, response?.data?.message);
                    setTimeout(() => context.commit(SET_ERROR, ""), 5000);
                });
        });
    },

    [DELETE_PERMISSION](context, id) {
        return new Promise((resolve) => {
            ApiService.delete(`Permissions`, id)
                .then((res) => {
                    resolve(res);
                })
                .catch(({ response }) => {
                    context.commit(SET_ERROR, response?.data?.message);
                    setTimeout(() => context.commit(SET_ERROR, ""), 5000);
                });
        });
    },
};

// MUTATIONS

const mutations = {
    [SET_ERROR](state, error) {
        state.error = error;
    },

    [SET_LIST_PERMISSIONS](state, permissions) {
        state.listPermissions = Object.assign({}, permissions);
    },
};

export default {
    state,
    actions,
    mutations,
    getters,
};
